"use client";

import * as React from "react";
import { ChartBlock, LiquidityPie } from "@/components";
import { useDex } from "@/hooks/use-liquidity";
import { LIQUIDITY_CHARTS } from "@/constants";

export function Dex() {
  const { data, isLoading } = useDex();
  const chartData = Array.isArray(data) ? data : [];

  return (
    <ChartBlock
      isSmall
      isRounded
      title="By DEX"
      isLoading={isLoading}
      className="overflow-visible"
      watermark={false}
    >
      <LiquidityPie
        data={chartData}
        colors={LIQUIDITY_CHARTS.DEX}
        isLoading={isLoading}
      />
    </ChartBlock>
  );
}
